import {Auction} from "domain-models"
import {currency} from 'filters'
import React from "react"
import BidModal from "./BidModal"
import Trans from '../../components/Trans'

type BidButtonProps = {
  tertiary?: boolean
  title: string
  auction: Auction
}

type BidButtonState = {
  showModal: boolean
}

class BidButton extends React.Component<BidButtonProps, BidButtonState> {
  constructor(props: BidButtonProps) {
    super(props)
    this.state = {
      showModal: false
    }
  };

  showModal = () => {
    this.setState({showModal: true})
  }

  hideModal = () => {
    this.setState({showModal: false})
  }

  render() {
    const auction = this.props.auction
    const auctionType = auction.round.Type
    return (
      <div className='w-full'>
        <button className={
          this.props.tertiary ? 'w-full rounded px-4 py-3 font-semibold whitespace-no-wrap shadow text-lg bg-gray-300 text-gray-800 hover:bg-gray-400'
            : "w-full rounded px-4 py-3 font-semibold whitespace-no-wrap shadow text-lg"
            + (auctionType === 0 ? ' bg-orange-500 text-orange-100 hover:bg-orange-600' : '')
            + (auctionType === 1 ? ' bg-blue-500 text-blue-100 hover:bg-blue-600' : '')
            + (auctionType === 2 ? ' bg-purple-500 text-purple-100 hover:bg-purple-600' : '')
        } onClick={() => this.showModal()}>
          {
            this.props.title ?
              <span><Trans>{this.props.title}</Trans></span>
              :
              <span>+ {currency(auction.round.bid.Bid)}</span>
          }
        </button>
        {this.state.showModal && auction ? <BidModal auction={auction} hideModal={this.hideModal}/> : null}
      </div>
    )
  }
}

export default BidButton
